import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { SummaryCard } from "@/components/Cards";
import { Step5 } from "@/components/FormSteps";

export const SummaryCard1: FC = () => {
  const { t } = useTranslation();

  return (
    <SummaryCard title={t("summary.card1")} dataTest="summary-card1">
      <Step5 isSummary />
    </SummaryCard>
  );
};
